import React from 'react'
import Content from './Content'
import Button from './Button'
import reception from "../images/reception.JPG"
const AboutUs = () => {
  return (
    <div className="container py-16 p-6 md:flex md:flex-row sm:flex-col md:w-4/5 sm:w-full md:max-h-prose mx-auto place-self-center">
   <div className="md:p-10 bg-white mt-4 mb-4 md:w-3/4 sm:w-full mx-auto h-3/4 z-10 border-1 place-self-center shadow-lg md:-mr-10">
        <Content isColor={true} title="ABOUT US"
        subtitle="lorem ipsum lorem"
        content="Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod neque minus, ducimus dolore veniam aspernatur optio quibusdam itaque, placeat, aliquam sit hic! Nam nihil fugiat aut totam, sequi unde nostrum."/>
<div className="m-3 p-3 md:w-1/2 sm:w-full"><Button href="/about" isColour="black" label='READ MORE'/></div>
        
      
</div>
      <img className="z-0 md:w-1/2 sm:w-full bg-cover" src={reception} alt="img"/> 
    
    
 </div>
  
      
      
  )
}

export default AboutUs